/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_League_Included2Inputs */

const ja_playdata_pricing_league_included2 = /** @type {(inputs: Playdata_Pricing_League_Included2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`11日目以降は追加料金3,500円/日が加算`)
};

const en_playdata_pricing_league_included2 = /** @type {(inputs: Playdata_Pricing_League_Included2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional days: ¥3,500/day`)
};

/**
* | output |
* | --- |
* | "Additional days: ¥3,500/day" |
*
* @param {Playdata_Pricing_League_Included2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_league_included2 = /** @type {((inputs?: Playdata_Pricing_League_Included2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_League_Included2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_league_included2(inputs)
	return en_playdata_pricing_league_included2(inputs)
});